import { getThreadId } from '../../../omnibus/public/operators';
import { buildThreadDetailsFromOmnibus } from './buildThreadDetailsFromOmnibus';
import { buildThreadHistoryFromOmnibus } from './buildThreadHistoryFromOmnibus';
export const buildInitialThreadViewStateFromOmnibus = omnibus => ({
  threadDetails: buildThreadDetailsFromOmnibus(omnibus),
  threadHistory: buildThreadHistoryFromOmnibus(omnibus),
  threadId: getThreadId(omnibus)
});